import { FC, ReactNode } from 'react';
import styles from './TripCartForm.module.scss';

type TripCartFormProps = {
  children: ReactNode;
};

const TripCartForm: FC<TripCartFormProps> = ({ children }) => (
  <form
    method="POST"
    name="trip-cart-cost-form"
    className={styles.root}
  >
    {children}
  </form>
);

export default TripCartForm;
